import { apiClient } from './api';
import { Notification, PaginatedResponse } from '../types';

interface BackendPaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  pages: number;
}

class NotificationService {
  // Admin APIs
  async sendNotification(data: {
    recipients?: string[];
    message: string;
    type: string;
    title: string;
  }): Promise<void> {
    await apiClient.post('/admin/notifications', data);
  }

  async getAdminNotifications(filters?: {
    unread?: boolean;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<Notification>> {
    const response = await apiClient.get<BackendPaginatedResponse<Notification>>('/admin/notifications', filters);
    return {
      items: response.data,
      total: response.total,
      page: response.page,
      limit: filters?.limit || 10,
      totalPages: response.pages
    };
  }

  // Member APIs
  async getMemberNotifications(filters?: {
    unread?: boolean;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<Notification>> {
    const response = await apiClient.get<BackendPaginatedResponse<Notification>>('/member/notifications', filters);
    return {
      items: response.data,
      total: response.total,
      page: response.page,
      limit: filters?.limit || 10,
      totalPages: response.pages
    };
  }

  async markAsRead(id: string): Promise<Notification> {
    return apiClient.patch<Notification>(`/member/notifications/${id}`, {});
  }
}

export const notificationService = new NotificationService();
